// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__qn_aM","checkboxCol":"Table_checkboxCol__X0RRL","emailCol":"Table_emailCol__29r2P","actionCol":"Table_actionCol__2KuIc"};